import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "children", "className", "disabled", "error", "id", "label", "name", "onChange", "selectedValue", "typographyProps", "value"],
    _excluded2 = ["marginProps"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { extractMarginProps } from '../../styling';
import SelectorLabel from '../SelectorLabel';
import { useRadioClassName } from './utils';
import { RadioInput, RadioMark, RadioRoot } from './style';
import { radioDefaultTheme } from './theme';
import { generateId } from '../../utils';
import { RADIO_CLASS_PREFIX, radioIdPrefix, radioRoot } from './constants';
export var Radio = forwardRef(function Radio(_ref, ref) {
  var checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      disabled = _ref.disabled,
      error = _ref.error,
      propsId = _ref.id,
      label = _ref.label,
      name = _ref.name,
      onChange = _ref.onChange,
      selectedValue = _ref.selectedValue,
      typographyProps = _ref.typographyProps,
      value = _ref.value,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(RADIO_CLASS_PREFIX, radioDefaultTheme);
  var id = generateId(propsId, radioIdPrefix);
  var isChecked = checked || value === selectedValue;
  var classOverride = useRadioClassName(RADIO_CLASS_PREFIX, className, disabled, isChecked, error);

  var handleOnChange = function handleOnChange(event) {
    return onChange && onChange(event);
  };

  var _extractMarginProps = extractMarginProps(restProps),
      marginProps = _extractMarginProps.marginProps,
      otherProps = _objectWithoutProperties(_extractMarginProps, _excluded2);

  return React.createElement(RadioRoot, Object.assign({
    className: classOverride.Root,
    "data-testid": radioRoot,
    theme: theme,
    disabled: disabled
  }, marginProps), React.createElement(RadioInput, Object.assign({}, otherProps, {
    checked: isChecked,
    className: classOverride.Input,
    disabled: disabled,
    id: id,
    name: name,
    onChange: handleOnChange,
    ref: ref,
    theme: theme,
    type: "radio",
    value: value
  })), React.createElement(RadioMark, {
    className: classOverride.Label,
    disabled: disabled,
    htmlFor: id,
    theme: theme
  }, React.createElement(SelectorLabel, {
    disabled: disabled,
    error: error,
    theme: theme,
    typographyProps: typographyProps
  }, label || children)));
});
Radio.displayName = RADIO_CLASS_PREFIX;
Radio.defaultProps = {
  checked: false,
  disabled: false,
  typographyProps: {
    paragraph: true,
    large: true
  }
};